module.exports = __webpack_public_path__ + "media/images/icons/x-fill-d0a59317a31db8c10e4e8d39ff7fbea0.svg";